import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { GoogleMap, LoadScript, Marker, Autocomplete } from "@react-google-maps/api";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { es as localeES } from "date-fns/locale";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import {
  HiOutlineWrenchScrewdriver, HiOutlinePhone, HiOutlineMapPin,
  HiOutlineClock, HiOutlineChevronDown, HiOutlineChevronUp,
  HiOutlinePlusCircle, HiOutlineTrash, HiOutlineCheck,
  HiOutlineCalendarDays, HiOutlineArrowTopRightOnSquare,
} from "react-icons/hi2";

const libraries = ["places"];

const AsignarServicio = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [position, setPosition] = useState({ lat: 20.659698, lng: -103.349609 });
  const [formData, setFormData] = useState({ direccion: "", calle: "", colonia: "", codigoPostal: "", ciudad: "", estado: "", latitud: 20.659698, longitud: -103.349609 });
  const autocompleteRef = useRef(null);

  const [editarDomicilio, setEditarDomicilio] = useState(false);
  const [mostrarDia, setMostrarDia] = useState(false);
  const [daysList, setDaysList] = useState([]);
  const [mostrarDaysList, setMostrarDaysList] = useState(false);
  const [sameHours, setSameHours] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedServices, setSelectedServices] = useState({ instalacion: false, capacitacion: false, diagnostico: false, mantenimiento: false, servicio_correctivo: false, garantia: false });
  const [isConnected, setIsConnected] = useState(false);
  const [editarContacto, setEditarContacto] = useState(false);
  const [formDataContacto, setFormDataContacto] = useState({ nombre: "", correo: "", telefono: "" });
  const [editarMaquina, setEditarMaquina] = useState(false);
  const [formDataMaquina, setFormDataMaquina] = useState({ familia: "", maquina: "" });
  const [range, setRange] = useState([{ startDate: new Date(), endDate: new Date(), key: "selection" }]);
  const [rangeOpen, setRangeOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchTicket = async () => {
    try {
      const response = await axios.get(`https://desarrollotecnologicoar.com/api8/ticket/${id}`);
      const ticketData = response.data;
      if (ticketData?.productDetails?.customFields?.["Calle y Número"]) {
        const direccionCompleta = `${ticketData.productDetails.customFields["Calle y Número"]}, ${ticketData.productDetails.customFields["Colonia"]}, ${ticketData.productDetails.customFields["Codigo Postal"]}, ${ticketData.productDetails.customFields["Ciudad"]}, ${ticketData.productDetails.customFields["Estado"]}`;
        setFormDataContacto((prev) => ({ ...prev, nombre: `${ticketData.contactDetails.firstName ? ticketData.contactDetails.firstName + " " : ""}${ticketData.contactDetails.lastName || ""}`.trim(), correo: ticketData.contactDetails.email || "", telefono: ticketData.contactDetails.phone || "" }));
        setFormDataMaquina((prev) => ({ ...prev, maquina: ticketData.productDetails.productName, familia: ticketData.productDetails.productCategory }));
        geocodeAddress(direccionCompleta, ticketData);
      }
      setTicket(ticketData);
    } catch (err) { setError("Error al obtener el ticket."); console.error(err); }
    finally { setLoading(false); }
  };

  const geocodeAddress = async (address, ticketData) => {
    try {
      const geocodeResponse = await axios.get("https://maps.googleapis.com/maps/api/geocode/json", { params: { address, key: "AIzaSyDHkpz3qbH2j6KuFgytJdSNEJp3Pp7XaL0" } });
      if (geocodeResponse.data.results.length > 0) {
        const location = geocodeResponse.data.results[0].geometry.location;
        setPosition({ lat: location.lat, lng: location.lng });
        setFormData((prev) => ({ ...prev, direccion: address, latitud: location.lat, longitud: location.lng, calle: ticketData.productDetails.customFields["Calle y Número"] || "", colonia: ticketData.productDetails.customFields["Colonia"] || "", codigoPostal: ticketData.productDetails.customFields["Codigo Postal"] || "", ciudad: ticketData.productDetails.customFields["Ciudad"] || "", estado: ticketData.productDetails.customFields["Estado"] || "" }));
        if (map) map.panTo({ lat: location.lat, lng: location.lng });
        if (marker) marker.setPosition({ lat: location.lat, lng: location.lng });
      }
    } catch (err) { console.error("Error al geocodificar la direccion:", err); }
  };

  useEffect(() => { fetchTicket(); }, [id, map, marker]);

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place && place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const ac = place.address_components;
        const g = (type) => { const c = ac?.find((comp) => comp.types.includes(type)); return c ? c.long_name : ""; };
        setPosition({ lat, lng });
        setFormData({ direccion: place.formatted_address, calle: g("route") + " " + g("street_number"), colonia: g("sublocality_level_1"), codigoPostal: g("postal_code"), ciudad: g("locality"), estado: g("administrative_area_level_1"), pais: g("country"), latitud: lat, longitud: lng });
        if (map) map.panTo({ lat, lng });
        if (marker) marker.setPosition({ lat, lng });
      }
    }
  };

  const handleMarkerDragEnd = (event) => {
    const lat = event.latLng.lat(); const lng = event.latLng.lng();
    setPosition({ lat, lng }); setFormData({ ...formData, latitud: lat, longitud: lng });
  };

  const generateDays = () => {
    const start = new Date(range[0].startDate); const end = new Date(range[0].endDate);
    start.setHours(0, 0, 0, 0); end.setHours(0, 0, 0, 0);
    const days = []; const cursor = new Date(start);
    while (cursor <= end) { days.push({ date: new Date(cursor), entrada: "", salida: "" }); cursor.setDate(cursor.getDate() + 1); }
    setDaysList(days); setMostrarDaysList(true);
  };

  const handleHourChange = (index, field, value) => {
    setDaysList((prev) => { const u = [...prev]; u[index][field] = value; if (sameHours) return u.map((d) => ({ ...d, [field]: value })); return u; });
  };

  const handleSameHoursChange = (e) => {
    const c = e.target.checked; setSameHours(c);
    if (c && daysList.length > 0) { const f = daysList[0]; setDaysList(daysList.map((d) => ({ ...d, entrada: f.entrada, salida: f.salida }))); }
  };

  const handleCheckboxChange = (event) => { const { name, checked } = event.target; setSelectedServices((prev) => ({ ...prev, [name]: checked })); };
  const handleRemoveDay = (index) => { setDaysList((prev) => prev.filter((_, i) => i !== index)); };

  const handleUpdateProductAddress = async () => {
    if (!ticket?.productDetails?.id) { alert("No se encontro el ID del producto."); return; }
    try { await axios.put(`https://desarrollotecnologicoar.com/api8/update-product/${ticket.productDetails.id}`, { calle: formData.calle, colonia: formData.colonia, ciudad: formData.ciudad, estado: formData.estado, codigoPostal: formData.codigoPostal }, { headers: { "Content-Type": "application/json" } }); alert("Domicilio actualizado correctamente"); fetchTicket(); }
    catch (error) { console.error("Error al actualizar el domicilio:", error.response?.data || error.message); alert("Hubo un error al actualizar el domicilio."); }
  };

  const handleUpdateContact = async () => {
    if (!ticket?.contactDetails?.id) { alert("No se encontro el ID del contacto."); return; }
    try { await axios.put(`https://desarrollotecnologicoar.com/api8/update-contact/${ticket.contactDetails.id}`, { email: formDataContacto.correo, phone: formDataContacto.telefono }, { headers: { "Content-Type": "application/json" } }); alert("Contacto actualizado correctamente"); fetchTicket(); }
    catch (error) { console.error("Error al actualizar el contacto:", error.response?.data || error.message); alert("Hubo un error al actualizar el contacto."); }
  };

  const handleUpdateFamily = async () => {
    if (!ticket?.productDetails?.id) { alert("No se encontro el ID del producto."); return; }
    try { await axios.put(`https://desarrollotecnologicoar.com/api8/update-family/${ticket.productDetails.id}`, { productCategory: formDataMaquina.familia || "", productName: formDataMaquina.maquina || "" }, { headers: { "Content-Type": "application/json" } }); alert("Informacion del producto actualizada correctamente"); }
    catch (error) { console.error("Error al actualizar la informacion del producto:", error.response?.data || error.message); alert("Hubo un error al actualizar la informacion del producto."); }
  };

  const handleTipoServicioChange = (event) => { setFormData((prev) => ({ ...prev, tipo_servicio: event.target.value })); };

  async function agregarGarantia(json, user, reservaId) {
    try {
      if (!json.itinerario || json.itinerario.length === 0) return { success: false, error: "Itinerario vacio." };
      const fechaEntrada = json.itinerario[0].fecha ? `${json.itinerario[0].fecha}T00:00:00.000Z` : null;
      const fechaSalida = json.itinerario[json.itinerario.length - 1].fecha ? `${json.itinerario[json.itinerario.length - 1].fecha}T23:59:59.999Z` : null;
      const response = await axios.post("https://teknia.app/api8/agregar_garantia", {
        id_ticket: json.general.ticketid, marca_temporal: new Date().toISOString(), email: user.email, prioridad: "Alta - Urgente/Escalación", ticket: json.general.ticket, quien_solicita: user.displayName, lista_negra: "", contacto_capacitado: "", razon_social: json.general.empresa, nombre_contacto: json.general.contacto, numero_contacto: json.general.telefono, soporte_para: "Garantía", tipo_venta: "", clasificacion_venta: "", gestion_venta: "", tipo_garantia: json.general.localidad, gestion_garantia: "Visita técnica presencial", clasificacion_garantia: "", num_pedido_venta: "", reincidencia: "", id_reserva_sql: reservaId, fecha_entrada: fechaEntrada, fecha_salida: fechaSalida,
      });
      const solicitudId = response.data.obj.id;
      const precio_venta = 470;
      const cantidad = json.itinerario.reduce((total, day) => { if (day.entrada && day.salida) { var mi = day.entrada.split(":").reduce((p, c) => parseInt(p) * 60 + parseInt(c)); var mf = day.salida.split(":").reduce((p, c) => parseInt(p) * 60 + parseInt(c)); total += (mf - mi) / 60; } return total; }, 0);
      await axios.post("https://teknia.app/api8/agregar_piezas", { id_solicitudes: solicitudId, piezas: [{ numero_parte: "S00015", descripcion: "SERVICIO TECNICO ESPEC (EQP AR)-HR-", cantidad: cantidad.toString(), unidad: "HORAS", costo_entrante: "1", clave_moneda_precio: "1", precio_venta: precio_venta.toString(), clave_moneda_costo: "1", precio_total: (precio_venta * cantidad).toString(), comentarios: "Requerimiento de servicio técnico", motivo: "Definir motivo" }], motivo: "Definir motivo", comentarios: "Requerimiento de servicio técnico" });
      return { success: true };
    } catch (error) { console.error("Error al agregar la garantia:", error.response?.data || error.message); return { success: false, error: error.toString() }; }
  }

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    const now = new Date(); const oneHourAhead = new Date(now.getTime() + 60 * 60 * 1000);
    for (const day of daysList) { if (day.date.toDateString() === now.toDateString() && day.entrada) { const [h, m] = day.entrada.split(":").map(Number); const scheduled = new Date(day.date); scheduled.setHours(h, m, 0, 0); if (scheduled < oneHourAhead) { alert("La hora de entrada debe programarse con al menos 1 hora de antelacion."); setIsSubmitting(false); return; } } }
    if (daysList.length === 0) { alert("Revisa bien el itinerario, falta seleccionar los dias y la hora de entrada y salida porfavor"); setIsSubmitting(false); return; }
    const actividades = Object.entries(selectedServices).filter(([_, s]) => s).map(([svc]) => svc);
    if (actividades.length === 0) { alert("Por favor, selecciona al menos una actividad."); setIsSubmitting(false); return; }

    const formDataJson = {
      general: { ticketid: ticket?.id || "", empresa: ticket?.accountDetails?.accountName || "", contacto: formDataContacto.nombre, equipo: formDataMaquina.maquina, numero_serie: "", ticket: ticket?.ticketNumber || "", fecha_reserva: now.toISOString(), hora_reserva: now.toLocaleTimeString("es-MX", { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" }), status: "Pendiente", correo_cliente: formDataContacto.correo || "", correo_tecnico: "", domicilio: formData.direccion, ciudad: formData.ciudad, telefono: formDataContacto.telefono, localidad: isConnected ? "Foráneo" : "Local", nombre_agente: user.displayName, correo_agente: user.email, tipo_servicio: formData.tipo_servicio },
      maquina: { modelo: formDataMaquina.maquina, familia: formDataMaquina.familia },
      contacto: { nombre: formDataContacto.nombre, email: formDataContacto.correo, telefono: formDataContacto.telefono },
      direccion: { calle: formData.calle, colonia: formData.colonia, codigoPostal: formData.codigoPostal, ciudad: formData.ciudad, estado: formData.estado, pais: formData.pais, latitud: formData.latitud, longitud: formData.longitud },
      actividades, itinerario: daysList.map((day) => ({ fecha: day.date.toISOString().split("T")[0], entrada: day.entrada, salida: day.salida })),
    };

    try {
      const response = await axios.post("https://desarrollotecnologicoar.com/api5/crear_reserva", formDataJson.general, { headers: { "Content-Type": "application/json" } });
      const reservaId = response.data.reserva.id;
      await axios.post("https://desarrollotecnologicoar.com/api5/itinerario_ticket", { reserva_id: reservaId, itinerario: formDataJson.itinerario });
      const actividadesData = formDataJson.actividades.map((actividad) => ({ reserva_id: reservaId.toString(), nombre_actividad: actividad }));
      await axios.post("https://desarrollotecnologicoar.com/api5/guardar_actividades", actividadesData);
      if (actividadesData.some((a) => a.nombre_actividad.toLowerCase() === "garantia")) {
        const garantiaResponse = await agregarGarantia(formDataJson, user, reservaId);
        if (!garantiaResponse.success) console.error("Error al agregar garantia:", garantiaResponse.error);
        alert("Reserva, Itinerario y Garantia guardados correctamente"); navigate("/actividad");
      } else { alert("Reserva y Itinerario guardados correctamente"); navigate("/actividad"); }
    } catch (error) {
      const mensajeError = error.response?.data?.error || error.message;
      if (mensajeError === "Ya existe una reserva para este ticket.") { alert("Este ticket ya tiene una reserva registrada. No se pueden crear duplicados."); }
      else { alert("Error al crear la reserva."); }
      console.error("Error al crear la reserva:", mensajeError);
    } finally { setIsSubmitting(false); }
  };

  if (loading) return <div className="page-container"><div className="flex items-center justify-center h-64"><svg className="w-8 h-8 animate-spin text-slate-400" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg></div></div>;
  if (error) return <div className="page-container"><div className="p-4 rounded-lg bg-red-50 border border-red-200 text-red-700">{error}</div></div>;

  const CollapseBtn = ({ isOpen, onClick }) => (
    <button onClick={onClick} className="p-1.5 text-slate-400 hover:text-slate-600 transition-colors">
      {isOpen ? <HiOutlineChevronUp className="w-5 h-5" /> : <HiOutlineChevronDown className="w-5 h-5" />}
    </button>
  );

  return (
    <LoadScript googleMapsApiKey="AIzaSyDHkpz3qbH2j6KuFgytJdSNEJp3Pp7XaL0" libraries={libraries}>
      <div className="flex flex-col lg:flex-row h-[calc(100vh-3.5rem)] lg:h-screen">
        {/* Left panel - Form */}
        <div className="w-full lg:w-96 xl:w-[420px] flex-shrink-0 overflow-y-auto bg-white border-r border-slate-200 p-5 space-y-4 order-1 lg:order-none">

          {/* Ticket Details */}
          <div className="card p-4">
            <div className="flex items-start justify-between">
              <div>
                <h2 className="font-semibold text-slate-900">Ticket #{ticket.ticketNumber}</h2>
                <p className="text-sm text-slate-600 mt-1">{ticket.subject}</p>
                <p className="text-xs text-slate-500 mt-1">Estatus: {ticket.status}</p>
                <p className="text-xs text-slate-500">Empresa: {ticket.accountDetails.accountName}</p>
              </div>
              <button onClick={() => window.open(`https://garantias.desarrollotecnologicoar.com/create/${id}`, "_blank")} className="p-1.5 text-slate-400 hover:text-blue-600 transition-colors" title="Ir a Garantias">
                <HiOutlineArrowTopRightOnSquare className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Machine */}
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <HiOutlineWrenchScrewdriver className="w-6 h-6 text-slate-500 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-900">Maquina</p>
                <p className="text-xs text-slate-500 truncate">{ticket.productDetails.productCategory}</p>
                <p className="text-xs text-slate-500 truncate">{ticket.productDetails.productName}</p>
              </div>
              <CollapseBtn isOpen={editarMaquina} onClick={() => setEditarMaquina(!editarMaquina)} />
            </div>
            {editarMaquina && (
              <div className="mt-3 pt-3 border-t border-slate-100 space-y-3">
                <div className="grid grid-cols-2 gap-3">
                  <div><label className="label">Familia</label><input type="text" value={formDataMaquina.familia} onChange={(e) => setFormDataMaquina({ ...formDataMaquina, familia: e.target.value })} className="input text-sm" /></div>
                  <div><label className="label">Maquina</label><input type="text" value={formDataMaquina.maquina} onChange={(e) => setFormDataMaquina({ ...formDataMaquina, maquina: e.target.value })} className="input text-sm" /></div>
                </div>
                <button onClick={handleUpdateFamily} className="btn-primary text-xs w-full">Guardar Cambios</button>
              </div>
            )}
          </div>

          {/* Contact */}
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <HiOutlinePhone className="w-6 h-6 text-slate-500 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-900">Contacto</p>
                <p className="text-xs text-slate-500 truncate">{`${ticket.contactDetails.firstName || ""} ${ticket.contactDetails.lastName || ""}`.trim()}</p>
                <p className="text-xs text-slate-500 truncate">{ticket.contactDetails.email}</p>
                <p className="text-xs text-slate-500">{ticket.contactDetails.phone}</p>
              </div>
              <CollapseBtn isOpen={editarContacto} onClick={() => setEditarContacto(!editarContacto)} />
            </div>
            {editarContacto && (
              <div className="mt-3 pt-3 border-t border-slate-100 space-y-3">
                <div className="grid grid-cols-2 gap-3">
                  <div><label className="label">Nombre</label><input type="text" value={formDataContacto.nombre} onChange={(e) => setFormDataContacto({ ...formDataContacto, nombre: e.target.value })} className="input text-sm" /></div>
                  <div><label className="label">Correo</label><input type="email" value={formDataContacto.correo} onChange={(e) => setFormDataContacto({ ...formDataContacto, correo: e.target.value })} className="input text-sm" /></div>
                </div>
                <div><label className="label">Telefono</label><input type="tel" value={formDataContacto.telefono} onChange={(e) => setFormDataContacto({ ...formDataContacto, telefono: e.target.value })} className="input text-sm" /></div>
                <button onClick={handleUpdateContact} className="btn-primary text-xs w-full">Guardar Cambios</button>
              </div>
            )}
          </div>

          {/* Address */}
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <HiOutlineMapPin className="w-6 h-6 text-slate-500 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-slate-900">Direccion</p>
                <p className="text-xs text-slate-500 truncate">{ticket.productDetails.customFields["Calle y Número"]}, {ticket.productDetails.customFields["Colonia"]}, {ticket.productDetails.customFields["Codigo Postal"]}</p>
                <p className="text-xs text-slate-500">{ticket.productDetails.customFields["Ciudad"]}, {ticket.productDetails.customFields["Estado"]}</p>
              </div>
              <CollapseBtn isOpen={editarDomicilio} onClick={() => setEditarDomicilio(!editarDomicilio)} />
            </div>
            {editarDomicilio && (
              <div className="mt-3 pt-3 border-t border-slate-100 space-y-3">
                <div>
                  <label className="label">Direccion</label>
                  <Autocomplete onLoad={(a) => (autocompleteRef.current = a)} onPlaceChanged={handlePlaceChanged}>
                    <input type="text" value={formData.direccion} onChange={(e) => setFormData({ ...formData, direccion: e.target.value })} className="input text-sm" autoComplete="off" />
                  </Autocomplete>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div><label className="label">Calle</label><input type="text" value={formData.calle} onChange={(e) => setFormData({ ...formData, calle: e.target.value })} className="input text-sm" /></div>
                  <div><label className="label">Colonia</label><input type="text" value={formData.colonia} onChange={(e) => setFormData({ ...formData, colonia: e.target.value })} className="input text-sm" /></div>
                  <div><label className="label">C.P.</label><input type="text" value={formData.codigoPostal} onChange={(e) => setFormData({ ...formData, codigoPostal: e.target.value })} className="input text-sm" /></div>
                  <div><label className="label">Ciudad</label><input type="text" value={formData.ciudad} onChange={(e) => setFormData({ ...formData, ciudad: e.target.value })} className="input text-sm" /></div>
                </div>
                <div><label className="label">Estado</label><input type="text" value={formData.estado} onChange={(e) => setFormData({ ...formData, estado: e.target.value })} className="input text-sm" /></div>
                <div className="grid grid-cols-2 gap-3">
                  <div><label className="label">Latitud</label><input type="text" value={formData.latitud} onChange={(e) => setFormData({ ...formData, latitud: e.target.value })} className="input text-sm" /></div>
                  <div><label className="label">Longitud</label><input type="text" value={formData.longitud} onChange={(e) => setFormData({ ...formData, longitud: e.target.value })} className="input text-sm" /></div>
                </div>
                <button onClick={handleUpdateProductAddress} className="btn-primary text-xs w-full">Guardar Cambios</button>
                <p className="text-xs text-slate-500 text-center">Arrastra el marcador en el mapa si la ubicacion no es correcta.</p>
              </div>
            )}
          </div>

          <hr className="border-slate-200" />

          {/* Activities */}
          <div className="card p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <HiOutlineWrenchScrewdriver className="w-5 h-5 text-slate-500" />
                <p className="text-sm font-medium text-slate-900">Actividades</p>
              </div>
              <button onClick={() => setOpen(true)} className="p-1.5 text-slate-400 hover:text-emerald-600 transition-colors"><HiOutlinePlusCircle className="w-5 h-5" /></button>
            </div>
            <div className="mt-2 space-y-1">
              {Object.entries(selectedServices).filter(([_, s]) => s).length > 0 ? (
                Object.entries(selectedServices).filter(([_, s]) => s).map(([svc]) => (
                  <div key={svc} className="flex items-center gap-2 text-xs text-emerald-700">
                    <HiOutlineCheck className="w-4 h-4" />
                    <span className="capitalize">{svc.replace(/_/g, " ")}</span>
                  </div>
                ))
              ) : (
                <p className="text-xs text-slate-400">Ninguna seleccionada aun</p>
              )}
            </div>
          </div>

          {/* Locality toggle */}
          <div className="card p-4">
            <p className="text-sm font-medium text-slate-900 mb-2">Localidad del Servicio</p>
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-slate-800">{isConnected ? "Foraneo" : "Local"}</span>
              <button onClick={() => setIsConnected(!isConnected)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${isConnected ? "bg-slate-900" : "bg-slate-300"}`}>
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${isConnected ? "translate-x-6" : "translate-x-1"}`} />
              </button>
            </div>
          </div>

          {/* Itinerary */}
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <HiOutlineClock className="w-6 h-6 text-slate-500 flex-shrink-0" />
              <p className="flex-1 text-sm font-medium text-slate-900">Itinerario</p>
              <CollapseBtn isOpen={mostrarDia} onClick={() => setMostrarDia(!mostrarDia)} />
            </div>
          </div>

          {mostrarDia && (
            <div className="space-y-3">
              {/* Date Range picker */}
              <div className="card p-4 cursor-pointer" onClick={() => setRangeOpen(!rangeOpen)}>
                <div className="flex items-center gap-3">
                  <HiOutlineCalendarDays className="w-5 h-5 text-slate-500" />
                  <div className="flex-1">
                    <p className="text-sm font-medium text-slate-900">
                      {`${range[0].startDate.toLocaleDateString("es-MX", { weekday: "short", month: "short", day: "numeric" })}  —  ${range[0].endDate.toLocaleDateString("es-MX", { weekday: "short", month: "short", day: "numeric" })}`}
                    </p>
                    <p className="text-xs text-slate-500">Selecciona el rango de dias</p>
                  </div>
                  <CollapseBtn isOpen={rangeOpen} onClick={(e) => { e.stopPropagation(); setRangeOpen(!rangeOpen); }} />
                </div>
              </div>

              {rangeOpen && (
                <div className="flex justify-center bg-white rounded-lg p-2 border border-slate-200">
                  <DateRange ranges={range} onChange={({ selection }) => { setRange([selection]); setMostrarDaysList(false); }} moveRangeOnFirstSelection={false} locale={localeES} rangeColors={["#0f172a"]} months={1} direction="horizontal" showMonthAndYearPickers weekStartsOn={1} />
                </div>
              )}

              <div className="card p-4">
                <div className="flex items-center gap-3">
                  <HiOutlineClock className="w-5 h-5 text-slate-500" />
                  <p className="flex-1 text-sm font-medium text-slate-900">Horas de entrada y salida</p>
                  <CollapseBtn isOpen={mostrarDaysList} onClick={generateDays} />
                </div>
              </div>

              {mostrarDaysList && daysList.length > 0 && (
                <>
                  <label className="flex items-center gap-2 cursor-pointer text-xs text-slate-700 ml-1">
                    <input type="checkbox" checked={sameHours} onChange={handleSameHoursChange} className="w-4 h-4 rounded border-slate-300 text-slate-900 focus:ring-slate-500" />
                    Usar el mismo horario para todos los dias
                  </label>
                  <div className="space-y-2">
                    {daysList.map((day, index) => (
                      <div key={index} className="flex items-center gap-2 p-2 bg-white border border-slate-200 rounded-lg">
                        <span className="flex-1 text-xs text-slate-700 capitalize">{day.date.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "short" })}</span>
                        <input type="time" value={day.entrada} onChange={(e) => handleHourChange(index, "entrada", e.target.value)} className="input w-28 py-1 text-xs" />
                        <input type="time" value={day.salida} onChange={(e) => handleHourChange(index, "salida", e.target.value)} className="input w-28 py-1 text-xs" />
                        <button onClick={() => handleRemoveDay(index)} className="p-1 text-slate-400 hover:text-red-600 transition-colors"><HiOutlineTrash className="w-4 h-4" /></button>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}

          {/* Submit */}
          <button onClick={handleSubmit} disabled={isSubmitting} className="btn-primary w-full text-sm py-3 font-bold">
            {isSubmitting ? <svg className="w-5 h-5 animate-spin mx-auto" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg> : "Listo"}
          </button>
        </div>

        {/* Right - Map */}
        <div className="flex-1 order-0 lg:order-none h-[40vh] lg:h-full">
          <GoogleMap center={position} zoom={16} mapContainerStyle={{ width: "100%", height: "100%" }} onLoad={(m) => setMap(m)}>
            <Marker position={position} draggable onDragEnd={handleMarkerDragEnd} onLoad={(m) => setMarker(m)} />
          </GoogleMap>
        </div>
      </div>

      {/* Activities Modal */}
      {open && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="mb-4 text-lg font-semibold text-slate-900">
              Selecciona las actividades
            </h3>

            <div className="grid grid-cols-2 gap-3 mb-4">
              {Object.keys(selectedServices).map((service) => (
                <label
                  key={service}
                  className="flex items-center gap-2 cursor-pointer text-sm text-slate-700"
                >
                  <input
                    type="checkbox"
                    name={service}
                    checked={selectedServices[service]}
                    onChange={handleCheckboxChange}
                    className="h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-500"
                  />
                  <span className="capitalize">{service.replace(/_/g, " ")}</span>
                </label>
              ))}
            </div>

            <button
              onClick={() => setOpen(false)}
              className="w-full rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
            >
              Listo
            </button>
          </div>
        </div>
      )}
    </LoadScript>
  );
};

export default AsignarServicio;
